import { SocialRelations } from "../../../SubjectData/BasicWords/Relationships.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";

export default function SocialRelationsDeck() {
  return (
    <>
      <HeaderNav GoBack_to="/RelationshipsNav" />
      <FlashcardInterface deckData={SocialRelations} title="Social Relationships" />
    </>
  );
}
